import {
  ADD_CONTACT,
  ADD_CONTACT_SUCCESS,
  ADD_CONTACT_FAILED,
  FETCH_CONTACT,
  FETCH_CONTACT_SUCCESS,
  FETCH_CONTACT_FAILED,
  ADD_JM_USER,
  ADD_JM_USER_SUCCESS,
  ADD_JM_USER_FAILED,
  FETCH_JM_USER,
  FETCH_JM_USER_SUCCESS,
  FETCH_JM_USER_FAILED
} from "../store/types";
// import {
//   language,
//   cloud_function_server_url,
//   mainUrl,
//   FirebaseConfig,
//   AppDetails,
//   PurchaseDetails,
// } from "config";
// import axios from "axios";

export const fetchContacts = () => (dispatch) => {
  dispatch({
    type: FETCH_CONTACT,
    payload: false
  });

  try {
    var myHeaders = new Headers();
    myHeaders.append(
      "X-Joomla-Token",
      "c2hhMjU2OjU4OmFhYjY0ZDVkMmE3YjU0OTk4OTEzMWQ4Yjc3MTcyNjEwNzAyNWIyMzNlNDZkNThkMDFlMTliODRmNjY0NTg3Njc="
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(
      "https://api-prop.plum.systems/api/index.php/v1/contacts",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  } catch (error) {
    dispatch({
      type: FETCH_CONTACT_FAILED,
      payload: error
    });
  }
};

export const addContact = (userData) => async (dispatch) => (firebase)=> {
  dispatch({
    type: ADD_CONTACT,
    payload: false
  });
const {contactRef}=firebase
  try {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "X-Joomla-Token",
      "c2hhMjU2OjU4OmFhYjY0ZDVkMmE3YjU0OTk4OTEzMWQ4Yjc3MTcyNjEwNzAyNWIyMzNlNDZkNThkMDFlMTliODRmNjY0NTg3Njc="
    );

    var raw = JSON.stringify({
      alias: userData.alias,
      catid: userData.catid,
      language: userData.language,
      name: userData.name,
      email_to: userData.email_to,
      mobile: userData.mobile
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(
      "https://api-prop.plum.systems/api/index.php/v1/contacts",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  } catch (error) {
    console.error(error);
    dispatch({
      type: ADD_CONTACT_FAILED,
      payload: error.message
    });
  }
};

export const fetchJmUser = () => async (dispatch) => {
  dispatch({
    type: FETCH_JM_USER,
    payload: false
  });

  try {
    var myHeaders = new Headers();
    myHeaders.append(
      "X-Joomla-Token",
      "c2hhMjU2OjU4OmFhYjY0ZDVkMmE3YjU0OTk4OTEzMWQ4Yjc3MTcyNjEwNzAyNWIyMzNlNDZkNThkMDFlMTliODRmNjY0NTg3Njc="
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(
      "https://api-prop.plum.systems/api/index.php/v1/users",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_JM_USER_FAILED,
      payload: error.message
    });
  }
};
export const addJmUser = () => async (dispatch) => {
  dispatch({
    type: ADD_JM_USER,
    payload: false
  });

  try {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "X-Joomla-Token",
      "c2hhMjU2OjU4OmFhYjY0ZDVkMmE3YjU0OTk4OTEzMWQ4Yjc3MTcyNjEwNzAyNWIyMzNlNDZkNThkMDFlMTliODRmNjY0NTg3Njc="
    );

    var raw = JSON.stringify({
      block: "0",
      email: "test@example.org",
      groups: ["2"],
      id: "0",
      lastResetTime: "",
      lastvisitDate: "",
      name: "nnn",
      params: {
        admin_language: "",
        admin_style: "",
        editor: "",
        helpsite: "",
        language: "",
        timezone: ""
      },
      password: "qwerty",
      password2: "qwerty",
      registerDate: "",
      requireReset: "0",
      resetCount: "0",
      sendEmail: "0",
      username: "ad"
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(
      "https://api-prop.plum.systems/api/index.php/v1/users",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  } catch (error) {
    console.error(error);
    dispatch({
      type: ADD_JM_USER_FAILED,
      payload: error.message
    });
  }
};
